import { inject, Injectable } from '@angular/core';
import { HttpMainService } from '../../http-main.service';
import { BankCardResponseModel, ListModel, ListRequestModel } from '@itb-monorepo/models';
import { Observable, of } from 'rxjs';
import { removeEmptyFields } from '@itb-monorepo/helper';
import { AuthService } from '../../utility-services/auth.service';

@Injectable()
export class SupporterCardsService {
  private _HttpMainService = inject(HttpMainService);
  private authService = inject(AuthService);

  baseUrl = '/finance/';

  getList(params: ListRequestModel): Observable<ListModel<BankCardResponseModel>> {
    if (!this.authService.hasAccess('cards:L'))
      return of();

    return this._HttpMainService.get(`${this.baseUrl}v1/cards`,  removeEmptyFields(params));
  }
    get(userId: string, number: string): Observable<BankCardResponseModel> {
      if (!this.authService.hasAccess('cards:R'))
        return of();

      const url = `${this.baseUrl}v1/users/${userId}/cards/${number}`;
      return this._HttpMainService.get(url);
    }
    review(documentID: string, model: unknown): Observable<BankCardResponseModel> {
      if (!this.authService.hasAccess('cards:S'))
        return of();
      return this._HttpMainService.patch(this.baseUrl + "v1/cards/" + documentID, model);
    }
}
